/* TRS guide kit (trs-discovery-revamp, W1). AJAX add-to-cart for form[data-trs-add].
   Without JS the forms still post to /cart/add. After a successful add we fire Stiletto's
   "apps:product-added-to-cart" (refreshes the quick cart + count) and open the quick cart. */
(function () {
  if (window.__trsGuideJs) return;
  window.__trsGuideJs = true;

  function openQuickCart() {
    var icons = document.querySelectorAll('a[data-js-cart-icon]');
    for (var i = 0; i < icons.length; i++) {
      if (icons[i].offsetParent !== null) { icons[i].click(); return; }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-trs-add]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    var label = btn && btn.querySelector('.tg-btn__label');
    var original = label ? label.textContent : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    var id = form.querySelector('input[name="id"]').value;
    fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; });
    }).then(function (res) {
      if (!btn) return;
      btn.classList.remove('is-busy');
      if (!res.ok) {
        if (label) label.textContent = (res.j && res.j.description) ? 'Sold out' : 'Try again';
        setTimeout(function () { if (label) label.textContent = original; btn.disabled = false; }, 2200);
        return;
      }
      btn.classList.add('is-added');
      if (label) label.textContent = btn.getAttribute('data-added-text') || 'Added';
      document.dispatchEvent(new CustomEvent('apps:product-added-to-cart'));
      setTimeout(openQuickCart, 350);
      setTimeout(function () {
        btn.classList.remove('is-added');
        if (label) label.textContent = original;
        btn.disabled = false;
      }, 2600);
    }).catch(function () { form.submit(); });
  });
})();
